import React, { FC } from 'react'

import InputItem from '../../../components/InputItem'
import { ITabBaseProps } from './types'
import { PRODUCT_STAGES } from './utils'

export const GenericImpacts: FC<ITabBaseProps> = ({ formik }) => {
  return (
    <div className="mb-5 mt-5">
      {PRODUCT_STAGES.map(({ value, label }) => (
        <div key={value}>
          <h6 className={'mt-5'}>{label} impacts</h6>
          <div className="piece-content-inputs mb-5">
            <InputItem
              name="Carbon Emissions"
              description="Please provide carbon emissions in g CO2 eq."
              type="input"
              addonTitle="g"
              onChange={formik.handleChange}
              formikName={`${value}.carbon`}
              showAsterisk
              formik={formik}
              defaultValue={formik.values[value].carbon === 0 ? '0' : formik.values[value].carbon}
            />
            <InputItem
              name="Land Use"
              description="Please provide Land use in m2*year."
              type="input"
              addonTitle="m2*y"
              onChange={formik.handleChange}
              formikName={`${value}.landUse`}
              showAsterisk
              formik={formik}
              defaultValue={formik.values[value].landUse === 0 ? '0' : formik.values[value].landUse}
            />
            <InputItem
              name="Eutrophication"
              description="Please provide eutrophication in g PO43- eq"
              type="input"
              addonTitle="g"
              onChange={formik.handleChange}
              formikName={`${value}.eutrophication`}
              formik={formik}
              showAsterisk
              defaultValue={
                formik.values[value].eutrophication === 0
                  ? '0'
                  : formik.values[value].eutrophication
              }
            />
            <InputItem
              name="Biodiversity. sp.yr*10^14"
              description="Please provide the Biodiversity impact in sp.yr*10^14."
              type="input"
              addonTitle="sp.yr*10^14"
              onChange={formik.handleChange}
              formikName={`${value}.biodiversity`}
              formik={formik}
              showAsterisk
              defaultValue={
                formik.values[value].biodiversity === 0 ? '0' : formik.values[value].biodiversity
              }
            />
            <InputItem
              name="Freshwater Withdrawal"
              description="Please provide water usage in L"
              type="input"
              addonTitle="L"
              onChange={formik.handleChange}
              formikName={`${value}.waterUsage`}
              formik={formik}
              showAsterisk
              defaultValue={
                formik.values[value].waterUsage === 0 ? '0' : formik.values[value].waterUsage
              }
            />
          </div>
        </div>
      ))}
    </div>
  )
}

export default GenericImpacts
